import { useMemo } from 'react';
function isTextPart(part) {
    return typeof part === 'object' && part !== null && 'type' in part && part.type === 'text' && 'text' in part && typeof part.text === 'string';
}
function isToolPart(part) {
    return typeof part === 'object' && part !== null && 'type' in part && typeof part.type === 'string' && part.type.startsWith('tool');
}
/**
 * Filters chat messages to only show visible ones
 * - All user messages are shown
 * - Assistant messages are only shown if they have text or tool parts
 * @param messages Array of chat messages
 * @returns Filtered array of visible messages
 */ export function useVisibleMessages(messages) {
    return useMemo(()=>{
        return messages.filter((m)=>{
            if (m.role !== 'assistant') return true;
            // Hide assistant messages that have neither text nor tool parts
            const hasText = Array.isArray(m.parts) && m.parts.some((p)=>{
                if (!isTextPart(p)) return false;
                return p.text.trim().length > 0;
            });
            const hasTool = Array.isArray(m.parts) && m.parts.some((p)=>isToolPart(p));
            return hasText || hasTool;
        });
    }, [
        messages
    ]);
}
